import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { CvTemplateOutput } from 'document/model/cv-template.output';

import { ApiQuery } from '../../../../common/model/api.query';
import { cvTemplateLocalization } from '../model/document.fragments';

@Injectable({ providedIn: 'root' })
export class FetchCvTemplateDocumentsApiQuery extends ApiQuery<
	CvTemplateOutput[],
	void
> {
	client = 'content';
	document = gql`
		query FetchCvTemplateDocuments {
			fetchCvTemplateDocuments {
				id
				organizationId
				updateTimestamp
				localizations {
					...CvTemplateLocalization
				}
				creationTimestamp
			}
		}
		${cvTemplateLocalization}
	`;
	method = 'fetchCvTemplateDocuments';
}
